// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activityCommunitiesMainContainer{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    /* background-color: aqua; */
    margin-top: 20px;
    padding-top: 20px;
}

.Communities-dispaly{
    width: 100%;
    
}
.Communities{
    width: 440px;
    min-height: 80px;
    /* background-color: #efeeed; */
    padding:25px 0px;
    border-radius:20px ;
    /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5); */
    font-size: 12px;
    background-color: white;
    border: solid 1px #dee0e1;
}
.head{
    font-size: 18px;
    font-weight: 500;
}

@media screen and (min-width: 768px) {
    .Communities{
       margin-top: 30px;
    }
}
.Community{
    display: flex;
    margin-top: 10px;
    margin-bottom: 20px;
    padding-left: 20px;
    
}
.Community-Details{
    margin-left: 20px;
    
}
.Community-Details h3{
    margin: 5px 8px 8px 0px;
    padding: 0;
    font-weight: 400;
}
.title{
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 0;
}
 .Unfollow{
     width: 71px;
     height: 24px;
    font-size: 12px;
    border: none;
    border-radius: 20px;
    text-transform: capitalize;
    /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5); */
    border: solid 1px #dee0e1;
    cursor: pointer;
}
.Unfollow:disabled{
    background-color: #D8D8D8;
    cursor: no-drop;
}
.Actions{
    margin-left: 15px;
    width:25px;
    height: 24px;
    border:none;
    border-radius:50px;
    /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5); */
    cursor: pointer;
    border: solid 1px #dee0e1;
}

@media(max-width:768px){
 
    .Communities{
        width: 350px;
    }
}
.CommunityImage{
    width:60px;
    height: 60px;
}
@media(max-width:425px){
    .Communities{
        width: 105%;
    }
    .head{
        text-align: center;
    }
}
@media(max-width:320px){
 
    .Communities{
        width: 105%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Community/Communites/Communities.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;;AAEf;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB;8CAC0C;IAC1C,eAAe;IACf,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;OACG,gBAAgB;IACnB;AACJ;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;;AAEtB;AACA;IACI,iBAAiB;;AAErB;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;CACC;KACI,WAAW;KACX,YAAY;IACb,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B;8CAC0C;IAC1C,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB;8CAC0C;IAC1C,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI;QACI,YAAY;IAChB;AACJ;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;;IAEI;QACI,WAAW;IACf;AACJ","sourcesContent":[".activityCommunitiesMainContainer{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    /* background-color: aqua; */\r\n    margin-top: 20px;\r\n    padding-top: 20px;\r\n}\r\n\r\n.Communities-dispaly{\r\n    width: 100%;\r\n    \r\n}\r\n.Communities{\r\n    width: 440px;\r\n    min-height: 80px;\r\n    /* background-color: #efeeed; */\r\n    padding:25px 0px;\r\n    border-radius:20px ;\r\n    /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n    font-size: 12px;\r\n    background-color: white;\r\n    border: solid 1px #dee0e1;\r\n}\r\n.head{\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n    .Communities{\r\n       margin-top: 30px;\r\n    }\r\n}\r\n.Community{\r\n    display: flex;\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n    padding-left: 20px;\r\n    \r\n}\r\n.Community-Details{\r\n    margin-left: 20px;\r\n    \r\n}\r\n.Community-Details h3{\r\n    margin: 5px 8px 8px 0px;\r\n    padding: 0;\r\n    font-weight: 400;\r\n}\r\n.title{\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    margin-bottom: 0;\r\n}\r\n .Unfollow{\r\n     width: 71px;\r\n     height: 24px;\r\n    font-size: 12px;\r\n    border: none;\r\n    border-radius: 20px;\r\n    text-transform: capitalize;\r\n    /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n    border: solid 1px #dee0e1;\r\n    cursor: pointer;\r\n}\r\n.Unfollow:disabled{\r\n    background-color: #D8D8D8;\r\n    cursor: no-drop;\r\n}\r\n.Actions{\r\n    margin-left: 15px;\r\n    width:25px;\r\n    height: 24px;\r\n    border:none;\r\n    border-radius:50px;\r\n    /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n    cursor: pointer;\r\n    border: solid 1px #dee0e1;\r\n}\r\n\r\n@media(max-width:768px){\r\n \r\n    .Communities{\r\n        width: 350px;\r\n    }\r\n}\r\n.CommunityImage{\r\n    width:60px;\r\n    height: 60px;\r\n}\r\n@media(max-width:425px){\r\n    .Communities{\r\n        width: 105%;\r\n    }\r\n    .head{\r\n        text-align: center;\r\n    }\r\n}\r\n@media(max-width:320px){\r\n \r\n    .Communities{\r\n        width: 105%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
